// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_c0uDE.ReactTable {
  font: normal 14px/20px Inter;
  color: var( --color-base700 );
  border: 1px solid var( --color-base100 );
  overflow: hidden;
  background-color: var( --color-base025 );
}
.table_c0uDE.ReactTable .rt-thead {
  z-index: 1;
  box-shadow: none;
  border-right: 0px solid var( --color-base100 );
  border-bottom: 1px solid var( --color-base100 );
  background-color: var( --color-white );
  border-top-color: var( --color-base100 );
  border-left-width: 0px;
  border-left-color: var( --color-base100 );
}
.table_c0uDE.ReactTable .rt-thead .rt-th {
  padding: var( --size-pad12 ) var( --size-padLarge );
  outline: none !important;
  overflow: hidden;
  text-align: left;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-transform: capitalize;
}
.table_c0uDE.ReactTable .rt-thead .rt-th.-sort-desc {
  box-shadow: inset 0px -1px var( --color-brand500 );
}
.table_c0uDE.ReactTable .rt-thead .rt-th.-sort-asc {
  box-shadow: inset 0px 1px var( --color-brand500 );
}
.table_c0uDE.ReactTable .rt-tbody .rt-tr-group .rt-tr.-odd {
  background-color: var( --color-base025 );
}
.table_c0uDE.ReactTable .rt-tbody .rt-tr-group .rt-tr.-even {
  background-color: var( --color-white );
}
.table_c0uDE.ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td {
  padding: var( --size-pad12 ) var( --size-padLarge );
  border-top: 0px solid var( --color-base100 );
  border-left: 0px solid var( --color-base100 );
  border-right: 1px solid var( --color-base100 );
  border-bottom: 0px solid var( --color-base100 );
}
.table_c0uDE.ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td:last-child {
  border-right: none;
}
.table_c0uDE.ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td:first-child {
  border-left: none;
}`, "",{"version":3,"sources":["webpack://./src/theme/Table.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wCAAwC;EACxC,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,8CAA8C;EAC9C,+CAA+C;EAC/C,sCAAsC;EACtC,wCAAwC;EACxC,sBAAsB;EACtB,yCAAyC;AAC3C;AACA;EACE,mDAAmD;EACnD,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,kDAAkD;AACpD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,mDAAmD;EACnD,4CAA4C;EAC5C,6CAA6C;EAC7C,8CAA8C;EAC9C,+CAA+C;AACjD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".table:global( .ReactTable ) {\n  font: normal 14px/20px Inter;\n  color: var( --color-base700 );\n  border: 1px solid var( --color-base100 );\n  overflow: hidden;\n  background-color: var( --color-base025 );\n}\n.table:global( .ReactTable .rt-thead ) {\n  z-index: 1;\n  box-shadow: none;\n  border-right: 0px solid var( --color-base100 );\n  border-bottom: 1px solid var( --color-base100 );\n  background-color: var( --color-white );\n  border-top-color: var( --color-base100 );\n  border-left-width: 0px;\n  border-left-color: var( --color-base100 );\n}\n.table:global( .ReactTable .rt-thead .rt-th ) {\n  padding: var( --size-pad12 ) var( --size-padLarge );\n  outline: none !important;\n  overflow: hidden;\n  text-align: left;\n  font-weight: 600;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  text-transform: capitalize;\n}\n.table:global( .ReactTable .rt-thead .rt-th.-sort-desc ) {\n  box-shadow: inset 0px -1px var( --color-brand500 );\n}\n.table:global( .ReactTable .rt-thead .rt-th.-sort-asc ) {\n  box-shadow: inset 0px 1px var( --color-brand500 );\n}\n.table:global( .ReactTable .rt-tbody .rt-tr-group .rt-tr.-odd ) {\n  background-color: var( --color-base025 );\n}\n.table:global( .ReactTable .rt-tbody .rt-tr-group .rt-tr.-even ) {\n  background-color: var( --color-white );\n}\n.table:global( .ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td ) {\n  padding: var( --size-pad12 ) var( --size-padLarge );\n  border-top: 0px solid var( --color-base100 );\n  border-left: 0px solid var( --color-base100 );\n  border-right: 1px solid var( --color-base100 );\n  border-bottom: 0px solid var( --color-base100 );\n}\n.table:global( .ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td:last-child ) {\n  border-right: none;\n}\n.table:global( .ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td:first-child ) {\n  border-left: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table_c0uDE`
};
export default ___CSS_LOADER_EXPORT___;
